import { useAuth } from "src/contexts/AuthContext"

/**
 * Role-access gate for UI elements — the JSX counterpart to CanCan's `can?`.
 *
 * Renders `children` only when the current membership's role grants `action`
 * on `resource` (see Role::RESOURCE_ACTIONS on the backend). Unauthorized
 * users see nothing (or the optional `fallback`).
 *
 *   <Can resource="leads" action="create">
 *     <Button onClick={openCreate}>New Lead</Button>
 *   </Can>
 *
 * This only controls what the UI shows — every gated endpoint is enforced by a
 * Pundit policy on the server regardless. Never treat this as a security
 * boundary; it's for hiding controls the user can't use.
 *
 * Pass `any` (array of [resource, action] pairs) instead of resource/action to
 * render when the user has ANY one of several permissions — handy for a control
 * that maps to more than one backend action.
 */
export function Can({ resource, action, any, children, fallback = null }) {
  const { can } = useAuth()

  const permitted = any
    ? any.some(([res, act]) => can(res, act))
    : can(resource, action)

  return permitted ? children : fallback
}
